/**
 * @property required - Requires non-empty data. Checks for empty arrays and strings containing only whitespaces.
 * @property requiredIf - Requires non-empty data only if provided property or predicate is true.
 * @property requiredUnless - Requires non-empty data only if provided property or predicate is false.
 * @property minLength - Requires the input to have a minimum specified length, inclusive. Works with arrays.
 * @property maxLength - Requires the input to have a maximum specified length, inclusive. Works with arrays.
 * @property minValue - Requires entry to have a specified minimum numeric value or Date.
 * @property maxValue - Requires entry to have a specified maximum numeric value or Date.
 * @property between - Checks if a number or Date is in specified bounds. Min and max are both inclusive.
 * @property alpha - Accepts only alphabet characters.
 * @property alphaNum - Accepts only alphanumerics.
 * @property numeric - Accepts only numerics.
 * @property integer - Accepts positive and negative integers.
 * @property decimal - Accepts positive and negative decimal numbers.
 * @property email - Accepts valid email addresses. Keep in mind you still have to carefully verify it on your server,
 * as it is impossible to tell if the address is real without sending verification email.
 * @property ipAddress - Accepts valid IPv4 addresses in dotted decimal notation like 127.0.0.1.
 * @property macAddress - Accepts valid MAC addresses like 00:ff:11:22:33:44:55.
 * Don't forget to call it macAddress(), as it has optional parameter.
 * You can specify your own separator instead of ':'.
 * Provide empty separator macAddress('') to validate MAC addresses like 00ff1122334455.
 * @property sameAs - Checks for equality with a given property.
 * @property url - Accepts only URLs.
 * @property or - Passes when at least one of provided validators passes.
 * @property and - Passes when all of provided validators passes.
 * @property not - Passes when provided validator would not pass, fails otherwise.
 * Can be chained with other validators like not(sameAs('field')).
 * property withParams - Not really a validator, but a validator modifier.
 * Adds a $params object to the provided validator.
 * Can be used on validation functions or even entire nested field validation objects.
 * Useful for creating your own custom validators.
 */
export default window.validators || {
    helpers: { withParams: () => ({}) },
    between: () => ({}),
    minLength: () => ({}),
    maxLength: () => ({})
};
